var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecording = function SvgRecording(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6C10.488 6 6 10.488 6 16s4.488 10 10 10 10-4.488 10-10S21.512 6 16 6Zm0 2c4.43 0 8 3.57 8 8s-3.57 8-8 8-8-3.57-8-8 3.57-8 8-8Z"
  })));
};
export default SvgRecording;